// @warp-css;
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classNames } from '@chbphone55/classnames';
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { reset } from '../styles.js';
import { styles } from './styles.js';
const ccSteps = {
    wrapper: 'w-full',
    horizontal: 'flex',
};
/**
 * Steps are used to show progress through a process or to guide users through a multi-step task.
 */
export class WarpStepIndicator extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * Display steps horizontally instead of vertically
         */
        this.horizontal = false;
        /**
         * Align steps to the right (vertical layout only)
         */
        this.right = false;
    }
    static { this.styles = [reset, styles]; }
    updated() {
        this.updateStepsContext();
    }
    /**
     * @internal
     */
    updateStepsContext() {
        // Provide context to child step elements
        const steps = this.querySelectorAll('w-step');
        steps.forEach((step, index) => {
            step.setContext({
                horizontal: this.horizontal,
                right: this.right,
                isLast: index === steps.length - 1,
                isFirst: index === 0,
            });
        });
    }
    render() {
        const classes = classNames([ccSteps.wrapper, this.horizontal && ccSteps.horizontal]);
        return html `
      <div role="list" class=${classes} ${this.horizontal && `style='display: grid; grid-auto-rows: 1fr;grid-template-columns: 1fr;'`}>
        <slot></slot>
      </div>
    `;
    }
}
__decorate([
    property({ type: Boolean, reflect: true })
], WarpStepIndicator.prototype, "horizontal", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], WarpStepIndicator.prototype, "right", void 0);
if (!customElements.get('w-step-indicator')) {
    customElements.define('w-step-indicator', WarpStepIndicator);
}
//# sourceMappingURL=step-indicator.js.map